"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoLinksAndDescDisconnected = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Tooltip = _interopRequireDefault(require("@concur/nui-widgets/lib/Tooltip/Tooltip"));
var _Link = _interopRequireDefault(require("@concur/nui-widgets/lib/Link/Link"));
var _ReadMore = _interopRequireDefault(require("./ReadMore"));
var _ConnectButton = _interopRequireDefault(require("./ConnectButton"));
var _ConnectionSection = _interopRequireDefault(require("./ConnectionSection"));
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/logoLinks.css") : void 0;
var _utils = require("../utils");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } // eslint-disable-line import/no-named-as-default
// can remove with triplink-app-flags cleanup
var LogoLinksAndDesc = exports.LogoLinksAndDescDisconnected = function LogoLinksAndDesc(_ref) {
  var listing = _ref.listing,
    toggleDetails = _ref.toggleDetails,
    detailsExpanded = _ref.detailsExpanded,
    listingDisabled = _ref.listingDisabled,
    betas = _ref.betas,
    useNewConnectionSection = _ref.useNewConnectionSection,
    onConnectListingConnectClick = _ref.onConnectListingConnectClick;
  var _listing$core = listing.core,
    icon = _listing$core.icon,
    isTriplinkPreferredApp = _listing$core.isTriplinkPreferredApp,
    categories = _listing$core.categories,
    _listing$localized = listing.localized,
    _listing$localized2 = _listing$localized === void 0 ? {} : _listing$localized,
    partnerListingURL = _listing$localized2.partnerListingURL,
    _listing$localized2$n = _listing$localized2.name,
    name = _listing$localized2$n === void 0 ? '' : _listing$localized2$n,
    _listing$localized2$t = _listing$localized2.title,
    title = _listing$localized2$t === void 0 ? '' : _listing$localized2$t,
    demonstrationURL = _listing$localized2.demonstrationURL,
    brochureURL = _listing$localized2.brochureURL,
    contactURL = _listing$localized2.contactURL,
    details = _listing$localized2.details,
    _listing$localized2$c = _listing$localized2.customLinks,
    customLinks = _listing$localized2$c === void 0 ? [] : _listing$localized2$c,
    partnerImage = listing.images.partnerImage;
  var links = {
    partnerListingURL: partnerListingURL,
    demonstrationURL: demonstrationURL,
    brochureURL: brochureURL,
    contactURL: contactURL
  };
  var renderLinks = function renderLinks(linksObj, customLinks) {
    var output = [];
    if (linksObj.partnerListingURL) {
      output.push(/*#__PURE__*/_react.default.createElement(_Link.default, {
        href: linksObj.partnerListingURL,
        className: "ac-details-link",
        id: "ac-partner-listing-url",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "VisitOurWebsite"
      })));
    }
    if (linksObj.demonstrationURL) {
      output.push(/*#__PURE__*/_react.default.createElement(_Link.default, {
        href: linksObj.demonstrationURL,
        id: "ac-demonstration-url",
        className: "ac-details-link",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "WatchDemo"
      })));
    }
    if (linksObj.brochureURL) {
      output.push(/*#__PURE__*/_react.default.createElement(_Link.default, {
        href: linksObj.brochureURL,
        className: "ac-details-link",
        target: "_blank",
        rel: "noopener noreferrer",
        id: "ac-brochure-url"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "Brochure"
      })));
    }
    var _iterator = _createForOfIteratorHelper(customLinks),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var customLink = _step.value;
        output.push(/*#__PURE__*/_react.default.createElement(_Link.default, {
          href: customLink.url,
          className: "ac-details-link",
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: customLink.text
        })));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (linksObj.contactURL) {
      output.push(/*#__PURE__*/_react.default.createElement(_Link.default, {
        href: (0, _utils.normalizeMailto)(linksObj.contactURL),
        id: "ac-contact-url",
        className: "ac-details-link",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "Support"
      })));
    }
    return output.map(function (el, i, arr) {
      return /*#__PURE__*/_react.default.createElement("span", {
        key: "".concat(i, "links")
      }, el, i < arr.length - 1 && ' | ');
    });
  };
  var renderReadMore = function renderReadMore() {
    return /*#__PURE__*/_react.default.createElement(_ReadMore.default, {
      text: details,
      betas: betas,
      isExpanded: detailsExpanded,
      expand: toggleDetails
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-9 col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-2 col-xs-3 imgDiv"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Partner Image",
    className: "icon-image",
    src: icon || partnerImage || '/static/images/brand/logo-SAPConcur-20171204.svg'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-6 col-xs-6 partner-name-and-title"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "ac-listing-name"
  }, name), /*#__PURE__*/_react.default.createElement("h3", {
    className: "ac-listing-title"
  }, title), (categories || []).includes('ENDORSED_APPS') && ((0, _utils.canAccessBeta)(betas, 'endorsed-apps-category') || _config.default.nui.endorsedCategoryEnabled) && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    message: /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "EndorsedHover"
    }),
    placement: "bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "endorsed-chip"
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    className: "endorsed-chip-text",
    id: "SAPConcurEndorsedApp"
  }))), (0, _utils.canAccessBeta)(betas, 'triplink-app-flags') && isTriplinkPreferredApp && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    message: /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "PreferredHover"
    }),
    placement: "bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "preferred-chip"
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    className: "preferred-chip-text",
    id: "Preferred"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-10 read-more-area"
  }, renderReadMore(), renderLinks(links, customLinks)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "clearfix visible-xs"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-3 col-xs-3"
  }, useNewConnectionSection ? /*#__PURE__*/_react.default.createElement(_ConnectionSection.default, {
    listing: listing,
    isDisabled: listingDisabled,
    onConnectListingConnectClick: onConnectListingConnectClick
  }) : /*#__PURE__*/_react.default.createElement(_ConnectButton.default, {
    listing: listing,
    isDisabled: listingDisabled
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    betas: state.betas || {},
    useNewConnectionSection: state.meta.useNewConnectionSection
  };
};
LogoLinksAndDesc.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1data: _propTypes.default.object
  }).isRequired,
  toggleDetails: _propTypes.default.func.isRequired,
  betas: _propTypes.default.object,
  detailsExpanded: _propTypes.default.bool.isRequired,
  useNewConnectionSection: _propTypes.default.bool,
  onConnectListingConnectClick: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)(LogoLinksAndDesc);